import { deepClone } from "../../utils/utils";
import { SkillProps, Skills } from "../skill";

export async function getSkillsRequest(): Promise<SkillProps[]> {
    const skillsString = localStorage.getItem('skills');
    if (skillsString) {
        let hash: { [key in SkillProps['id']]?: number } = {};

        Skills.forEach((skill, index) => hash[skill.id] = index);

        let skills = deepClone(Skills);
        let savedSkills: SkillProps[] = JSON.parse(skillsString);

        savedSkills.forEach(skill => {
            skills[hash[skill.id] as number].xpTotal = skill.xpTotal;
        })
        return skills;
    };
    return Skills;
}